import { SET_TOKEN, SIGNIN_SUCCESS, UPDATE_TOKEN } from "../types/type";

const initialState = {
  isLogin: null,
  userDetail: null,
  tokens: null
};

const login = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SIGNIN_SUCCESS:
      return {
        ...state,
        userDetail: payload,
        isLogin: true
      };
    case SET_TOKEN:
      return {
        ...state,
        tokens: payload
      };
    case UPDATE_TOKEN:
      return {
        ...state,
        tokens: payload
      }
    default:
      return state;
  }
};

export default login;
